import styled, {css} from 'styled-components';

export const RowStyles = css`
  display: flex;
  flex-wrap: wrap;
`;

export const SectionDefaultStyles = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
`;

export const ButtonDefaultStyles = css`
  display: flex;
  border-radius: 0.4rem;
  border: none;
  cursor: pointer;
`;

export const RowW100Styles = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const RowW50Styles = css`
  display: flex;
  flex-wrap: wrap;
  width: 50%;
`;

export const ColumnStyles = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

export const ColumnW100Styles = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
`;

export const ColumnW50Styles = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

export const ColumnW100Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ColumnW100Div = styled(Column)`
  width: 100%;
`;

export const ColumnW50Div = styled(Column)`
  width: 50%;
`;

export const CenteredRow = styled(Row)`
  align-items: center;
`;
